module.exports = __webpack_public_path__ + "img/53.92696f19.png";